import React from "react";

import {templates} from "@reactivated";

import {Layout} from "@client/components/Layout";
import { FeatureCard } from "@client/components/FeatureCard";
import { HeroSection } from "@client/components/HeroSection";

export const Template = (props: templates.HomePage) => (
    <Layout title="HomePage">
        <HeroSection></HeroSection>
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
          <div className="grid md:grid-cols-3 gap-8">
            <FeatureCard
                title="Track Projects"
                description="Monitor the progress of AI incubation projects across different stages of development."
                href="/projects/"
            />
            <FeatureCard
                title="Safe Experimentation"
                description="Safely experiment with AI tools and methods in dedicated sandboxes."
                href="/playground/"
            />
            <FeatureCard
                title="Research Integration"
                description="Monitor ELT research and AI research and market trends."
                href="/research/"
            />
          </div>
        </section>
    </Layout>
);
